import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id FAC52832-EA67-4ABF-9841-7D3DD07C6EFF
 * name bread-slice-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bread-slice-outline.svg
 * tags
 * - Food / Drink 
 */
export const BreadSliceOutlineIcon = createSvgIcon(<><path d="M12,2C17.5,2 22,5.36 22,9.5C22,11.19 21.26,12.75 20,14V22H4V14C2.74,12.75 2,11.19 2,9.5C2,5.36 6.5,2 12,2M18,13.14C19.24,12.17 20,10.89 20,9.5C20,6.46 16.42,4 12,4C7.58,4 4,6.46 4,9.5C4,10.89 4.76,12.17 6,13.14V20H18V13.14M8,18V14H12V18H8Z" /></>, 'BreadSliceOutlineIcon');
export default BreadSliceOutlineIcon